import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqGroups } from '@/mocks/faqs';
import SectionHeading from '@/components/feature/SectionHeading';

export default function FaqPreviewSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const items = faqGroups.flatMap((group) => group.items).slice(0, 5);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="常见问题"
        title="你可能正想问的几件事"
        description="关于内容来源、风险等级和反馈方式，这里先集中回答一遍。"
      />

      <div className="max-w-3xl">
        <div className="flex flex-col divide-y divide-background-200 border-y border-background-200">
          {items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full flex items-center justify-between gap-4 py-4 text-left cursor-pointer group"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {item.q}
                  </span>
                  <span className={`w-8 h-8 rounded-full border flex items-center justify-center shrink-0 transition-colors ${isOpen ? 'bg-primary-500 border-primary-500 text-background-50' : 'border-background-300 text-foreground-500'}`}>
                    <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="pb-5 pr-12 text-sm text-foreground-600 leading-relaxed font-body">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>

        <Link
          to="/faq"
          className="mt-8 inline-flex items-center gap-2 text-sm font-label text-primary-700 hover:text-primary-800"
        >
          查看全部常见问题
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}